import React from "react";
import { Badge } from "../ui/badge";

export default function PageHeader({ eyebrow, title, description, badge }) {
  return (
    <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.28em] text-primary">{eyebrow}</p>
        <h1 className="mt-2 text-3xl font-extrabold text-panel-ink">{title}</h1>
        <p className="mt-2 max-w-2xl text-sm leading-6 text-panel-muted">{description}</p>
      </div>
      {badge ? <Badge>{badge}</Badge> : null}
    </div>
  );
}
